/**
 * Assigns and resolves stable short refs (e1, e2, …) for live elements.
 * Refs survive re-snapshots while the element lives; resolving a ref whose
 * element has been removed yields `undefined` (the tool layer maps this to a
 * `stale_ref` error).
 */
export class RefRegistry {
    #counter = 0;
    #byEl = new WeakMap();
    #byRef = new Map();
    /** Get an existing ref for the element or mint a new one. */
    refFor(el) {
        const existing = this.#byEl.get(el);
        if (existing)
            return existing;
        const ref = `e${++this.#counter}`;
        this.#byEl.set(el, ref);
        this.#byRef.set(ref, new WeakRef(el));
        return ref;
    }
    /** Resolve a ref to its element, or undefined if gone/detached. */
    resolve(ref) {
        const el = this.#byRef.get(ref)?.deref();
        if (!el)
            return undefined;
        if (!el.isConnected)
            return undefined;
        return el;
    }
}
//# sourceMappingURL=refs.js.map